import { Collapse } from 'antd';
import ContactForm from '../forms/contactForm'
// import { useSelector } from 'react-redux';
const { Panel } = Collapse;

const ContactDetails = () => {
  // const {contactDetails,validationCheck } = useSelector((state) => state.cardReducer);
  const onChange = (key) => {
    console.log(key);
  };
  return (
    <Collapse defaultActiveKey={['0']} onChange={onChange} >
      {/* className={contactDetails?.address&&contactDetails?.state&&contactDetails?.country&&contactDetails?.emailAddress||!validationCheck?"":`border-red-500`} */}
      <Panel header="Contact Details" key="1">
      <ContactForm/>
      </Panel>

    </Collapse>
  );
};
export default ContactDetails;